//@flow
/*
  This function take a string in the format:
  /pattern/flags
  and return a JS regex
*/
function has(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

export function createRegex(regexFromSchema) {
  let matches = /\/(.*)\/(.*)/.exec(regexFromSchema);

  if (Array.isArray(matches)) {
    return new RegExp(matches[1], matches[2]);
  } else {
    return /.*/;
  }
}

export function useRegex(schema, propName) {
  if (has(schema, ["regex", propName])) {
    return createRegex(schema[propName].regex);
  } else {
    return null;
  }
}

export default createRegex;
